module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Calculate your pension gap","tabs":{"basic":"Basic","advanced":"Advanced"},"CTA":"Recalculate pension gap"},"de":{"title":"Berechne deine Rentenlücke","tabs":{"basic":"Allgemeine Angaben","advanced":"Zusätzliche Angaben"},"CTA":"Rentenlücke neu berechnen"}}')
  delete Component.options._Ctor
}
